<h1 class="mt-5">Acceso a portal de calificaciones</h1>

<div class="form">
	<div class="row mt-5 align-items-end">
		<div class="col-2">
			<label class="titulo_criterios" for="select_anyo">Año</label>
			<label class="titulo_criterios-obligatorio ml-2" for="select_anyo">(obligatorio)</label>
			<select id="select_anyo" class="form-control select_criterios" [(ngModel)]="filtroAnyo" (ngModelChange)="resetearValidacion();cargarFiltros('anyo')">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let anyo of listaAnyo" [value]="anyo">{{anyo}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['anyo']" class="invalid-feedback">
				<div *ngIf="tieneErrores['anyo']">Campo requerido</div>
			</div>
		</div>
		<div class="col-2">
			<label class="titulo_criterios" for="select_periodo">Periodo</label>
			<label class="titulo_criterios-obligatorio ml-2" for="select_periodo">(obligatorio)</label>
			<select id="select_periodo" class="form-control select_criterios" [(ngModel)]="filtroPeriodo" (ngModelChange)="resetearValidacion();cargarFiltros('periodo')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }">
					<option [value]="0">Seleccionar</option>
					<option *ngFor="let periodo of listaPeriodo" [value]="periodo.periodoAcademicoId">{{periodo.periodoDescripcion}}</option>
			</select>
			<div *ngIf="submitted && tieneErrores['periodo']" class="invalid-feedback">
					<div *ngIf="tieneErrores['periodo']">Campo requerido</div>
			</div>
		</div>
	
		<div class="col-3">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
			<label class="titulo_criterios-obligatorio ml-2" for="exampleFormControlSelect2">(obligatorio)</label>
			<select id="select_periodo" class="form-control select_criterios" [(ngModel)]="filtroSede" (ngModelChange)="resetearValidacion();cargarFiltros('sede')" [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodo'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let sede of listaSede" [value]="sede.sedeId">{{sede.descripcion}}</option>
			</select>
		</div>
		<div class="col-3">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Sección</label>
			<ng-select 
				[notFoundText]="'No se encontraron resultados'"
				[loadingText]="'Buscando...'"
				placeholder="Ingresar sección"
				[loading]="loadingSecciones" 
				[items]="listaSeccion.listado" 
				bindLabel="seccion" 
				bindValue="idSeccion" 
				[virtualScroll]="true" 
				(scrollToEnd)="endScrollSecciones(searchValueSecciones)"
				(change)="onItemChangeSecciones($event)"
				(search)="onSearchSecciones($event)"
				(clear)="onClearSecciones($event)"
				[(ngModel)]="filtroSeccion"
				#selectSeccion
			>
			</ng-select>
		</div>
		<div class="col-2">
			<button [disabled]="!camposRequeridos()" (click)="navToPortalDocente()" class="boton-primario ml-3" [ngClass]="camposRequeridos() ? '' : 'disabled-button'" data-toggle="tooltip" data-placement="top" title="IR" alt="IR">IR</button>
		</div>
	</div>
	<div class="row mt-2 align-items-start">
		<div class="col-6">
			<label class="titulo_criterios" for="exampleFormControlSelect2">ID Docente</label>
			<label class="titulo_criterios-obligatorio ml-2" for="exampleFormControlSelect2">(obligatorio)</label>

			<ng-select 
				[notFoundText]="'No se encontraron resultados'"
				[loadingText]="'Buscando...'"
				[placeholder]="placeholderDocente"
				[loading]="loadingDocentes" 
				[items]="filteredDocentes" 
				bindLabel="codigo"
				bindValue="codigo" 
				[virtualScroll]="true" 
				(scrollToEnd)="endScrollDocentes(searchValueDocentes)"
				(change)="onItemChangeDocentes($event, selectDocente)"
				(search)="onSearchDocentes($event)"
				(clear)="onClearDocentes($event)"
				[(ngModel)]="filtroIdDocente"
				#selectDocente
			>
				<ng-template ng-option-tmp let-item="item" let-index="index">
					<span><b>{{item.codigo}}</b> - {{item.primerNombre}} {{item.apellidoPat	}} {{item.apellidoMat	}}</span>
				</ng-template>
			</ng-select>
			<p class="mt-2 nombre-docente-cstm" *ngIf="currDocente">Nombre docente: {{ currDocente.primerNombre }} {{ currDocente.apellidoPat }} {{ currDocente.apellidoMat }}</p>
		</div>
	</div>
</div>